import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/lib/auth";
import { SiteContentProvider } from "@/lib/siteContent";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Designer from "@/pages/Designer";
import MyDesigns from "@/pages/MyDesigns";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-16 text-center text-[#A39E93]">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteContentProvider>
            <Toaster theme="dark" position="bottom-right" />
            <Layout>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/designer" element={<Designer />} />
                <Route path="/designs" element={<Protected><MyDesigns /></Protected>} />
                <Route path="/admin" element={<Protected role="admin"><Admin /></Protected>} />
                <Route path="/checkout/success" element={<Protected><CheckoutSuccess /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </SiteContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
